import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common Entities => publishing destinations => ');

//publishingDestinationData is JSON object containing channelId, displayContainerId, displayUnitId, smartUrlId

const expire = createAction('expire publishing destination', (displayContainerId) => ({
  displayContainerId,
}));

const preview = createAction('preview the publishing destination', (publishingDestinationData) => ({
  publishingDestinationData,
}));

const goToChannel = createAction('go to channel', (channelId) => ({
  channelId,
}));

const publish = createAction('publish publishing destination', (displayContainerId) => ({
  displayContainerId,
}));

// No updatePublishingDestinationSuccess because we only store the ids and they don't change on updates.
// The individual components that make up a publishing destination get updated
const updatePublishingDestination = createAction('update publishing destination');

const updatePublishingDestinationFailure = createApiFailureAction('update publishing destination failure');

const validateAndUpdatePublishingDestination = createAction('validate and update publishing destination', (formId) => ({
  formId,
}));

const fetchPublishingDestinations = createAction('fetch publishing destinations new', (experienceId) => ({
  experienceId,
}));

const fetchPublishingDestinationsFailure = createApiFailureAction('failed to fetch publishing destinations');

const fetchPublishingDestinationsSuccess = createAction(
  'successfully fetched publishing destinations',
  (publishingDestinations) => ({ publishingDestinations })
);

const createPublishingDestination = createAction('create publishing destination', (isStaging) => ({ isStaging }));

const createPublishingDestinationSuccess = createAction(
  'create publishing destination success',
  (publishingDestination) => ({ publishingDestination })
);

const createPublishingDestinationFailure = createApiFailureAction('create publishing destinattion failure');

const removePublishingDestination = createAction(
  'remove publishing destination from experience',
  (publishingDestinationData) => ({ publishingDestinationData })
);

const removePublishingDestinationFailure = createApiFailureAction(
  'failed to remove publishing destination from experience',
  (id) => ({ id })
);

const removePublishingDestinationSuccess = createAction(
  'successfully removed publishing destination from experience',
  (publishingDestinationData) => ({ publishingDestinationData })
);

const editPublishingDestination = createAction(
  'edit a publishing destination',
  (publishingDestinationData, activeTab) => ({ publishingDestinationData, activeTab })
);

const checkCampaignValidityFailure = createApiFailureAction('failed to check a campaign publishing validity');

const setActivePublishingDestination = createAction(
  'set an active publishing destination',
  (publishingDestination) => ({ publishingDestination })
);

const showOverlay = createAction('show a web embed overlay as a preview', (overlayContainer) => ({ overlayContainer }));

const closeOverlay = createAction('close a web overlay popup');

const changeEditModalTab = createAction('change edit modal tab', (activeTab) => ({ activeTab }));

const hidePublishingDestinationEditor = createAction('hide the publishing destination edit modal');

const showPublishingDestinationEditor = createAction(
  'show the publishing destination edit modal',
  (publishingDestination, activeTab) => ({ publishingDestination, activeTab })
);

const updateActivePublishingDestination = createAction(
  'update the active publishing destination',
  (publishingDestination) => ({ publishingDestination })
);

const updateLightboxConfig = createAction('update the active publishing destination lightbox config', (config) => ({
  config,
}));

const updateWebEmbedConfig = createAction('update the active publishing destination web embed config', (config) => ({
  config,
}));

const updateIsTestMode = createAction('update the active publishing destination isTestMode', (isTestMode) => ({
  isTestMode,
}));

const updateTargetingRulesConfig = createAction('update targeting rules config', (config) => ({
  config,
}));

const changeEditorConfigVisibility = createAction('hide/show editor config pane', (isEditorConfigVisible) => ({
  isEditorConfigVisible,
}));

const statusAction = createAction('status action triggered', (displayContainerId, statusAction) => ({
  displayContainerId,
  statusAction,
}));

const statusActionFailure = createApiFailureAction('status action failure', (error) => ({
  error,
}));

/* WIZARD/EDITION ACTIONS */
const cancelAddDestinationWizard = createAction('cancel the add destination wizard');

const finishSaving = createAction('finish saving');

const savePublishingDestination = createAction('initiates the save destination request');

const savePublishingDestinationFailure = createAction('save publishing destination failure');

const savePublishingDestinationSuccess = createAction('save publishing destination success');

const finishDestinationCreationFailure = createAction('finish destination creation failure', (error) => ({ error })); // not a standard API error, but a proxy

const finishDestinationCreationSuccess = createAction(
  'finish destination creation success',
  (publishingDestination) => ({ publishingDestination })
);

const selectChannel = createAction(
  'select a channel in wizard',
  (id, moveTo, moveNext, destinationType, shouldMoveNext) => ({
    id,
    moveTo,
    moveNext,
    destinationType,
    shouldMoveNext,
  })
);

const selectPublishingManager = createAction('select a placement manager in wizard', (publishingManagerId) => ({
  publishingManagerId,
}));

const selectDisplayUnit = createAction('select a display unit in wizard', (id) => ({ id }));

const selectPinnedContainer = createAction('select a pinned container in wizard', (pinnedContainer) => ({
  pinnedContainer,
}));

const selectDestinationType = createAction('select a destination type in wizard', (id, moveNext, moveTo) => ({
  id,
  moveNext,
  moveTo,
}));
const setDimensions = createAction('set dimensions in wizard', (xDimension, yDimension) => ({
  xDimension,
  yDimension,
}));

const selectPrivacyManagement = createAction('select a cookie consent management mode in wizard', (privacyMgmt) => ({
  privacyMgmt,
}));

const updatePrivacyManagementConfig = createAction('update cookie consent management config', (privacyConfig) => ({
  privacyConfig,
}));

const setSchedulingDates = createAction('set the scheduling dates in wizard', (publishDate, expiryDate) => ({
  publishDate,
  expiryDate,
}));

const bootstrapWizard = createAction('validate and show the wizard', (mode, seedData = {}) => ({ mode, seedData }));

const showWizard = createAction('show the wizard', (mode, seedData = {}) => ({ mode, seedData }));

const startOverWizard = createAction('start the wizard over');

const resetWizard = createAction('reset the wizard data', (isStaging) => ({ isStaging }));

const manageChannels = createAction('manage channels');

const setLightboxConfig = createAction('set lightbox config', (config) => ({ config }));

const fetchPinnedContainersAndMoveNext = createAction(
  'set lightbox config',
  (moveTo, destinationType, selectedChannelId) => ({ moveTo, destinationType, selectedChannelId })
);

// Sets which Placement Manager the active destination should publish through
// (not to be confused with Channel.Actions.updatePublishingManager, which renames a placement manager)
const setDestinationPublishingManager = createAction('set destination placement manager', (publishingManagerId) => ({
  publishingManagerId,
}));

const fetchPublishingManagers = createAction('fetch placement managers', (channelId) => ({ channelId }));
const fetchPublishingManagersSuccess = createAction('fetch placement managers success', (publishingManagers) => ({
  publishingManagers,
}));
const fetchPublishingManagersFailure = createApiFailureAction('fetch placement managers failure', (error) => ({
  error,
}));

const toggleTestMode = createAction('toggle test mode', (displayContainerId, isTestMode) => ({
  displayContainerId,
  isTestMode,
}));
const toggleTestModeSuccess = createAction('toggle test mode success', (displayContainerId) => ({
  displayContainerId,
}));
const toggleTestModeFailure = createAction('toggle test mode failure', (displayContainerId) => ({
  displayContainerId,
}));

export default {
  expire,
  preview,
  goToChannel,
  publish,
  updatePublishingDestination,
  updatePublishingDestinationFailure,
  validateAndUpdatePublishingDestination,
  editPublishingDestination,
  fetchPublishingDestinations,
  fetchPublishingDestinationsFailure,
  fetchPublishingDestinationsSuccess,
  createPublishingDestination,
  createPublishingDestinationSuccess,
  createPublishingDestinationFailure,
  removePublishingDestination,
  removePublishingDestinationFailure,
  removePublishingDestinationSuccess,
  checkCampaignValidityFailure,
  showOverlay,
  closeOverlay,
  setActivePublishingDestination,
  changeEditModalTab,
  hidePublishingDestinationEditor,
  showPublishingDestinationEditor,
  updateActivePublishingDestination,
  updateLightboxConfig,
  updateWebEmbedConfig,
  updateIsTestMode,
  updateTargetingRulesConfig,
  changeEditorConfigVisibility,
  statusAction,
  statusActionFailure,
  setDestinationPublishingManager,
  fetchPublishingManagers,
  fetchPublishingManagersSuccess,
  fetchPublishingManagersFailure,

  cancelAddDestinationWizard,
  finishSaving,
  savePublishingDestination,
  savePublishingDestinationFailure,
  savePublishingDestinationSuccess,
  finishDestinationCreationFailure,
  finishDestinationCreationSuccess,
  selectChannel,
  selectPublishingManager,
  selectDestinationType,
  selectDisplayUnit,
  selectPinnedContainer,
  selectPrivacyManagement,
  updatePrivacyManagementConfig,
  setSchedulingDates,
  bootstrapWizard,
  showWizard,
  startOverWizard,
  resetWizard,
  setDimensions,
  manageChannels,
  setLightboxConfig,
  fetchPinnedContainersAndMoveNext,
  toggleTestMode,
  toggleTestModeSuccess,
  toggleTestModeFailure,
};
